import React from "react";
import PropTypes from "prop-types";

class DragAnchor extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      anchorX: undefined,
      anchorY: undefined
    }
  }

  onDrag = (event) => {
    event.preventDefault();
    const {clientX, clientY} = event;

    if (clientX === 0 && clientY === 0) {
      return;
    }

    const dragX = clientX - this.state.anchorX;
    const dragY = clientY - this.state.anchorY;

    this.props.onDrag(dragX, dragY);
  }

  setAnchor = ({clientX, clientY}) => {
    const rect = this.props.getDraggedRect();
    const x = clientX - rect.left; //x position within the element.
    const y = clientY - rect.top;  //y position within the element.

    this.setState({
      anchorX: x,
      anchorY: y
    })
  }

  resetAnchor = () => {
    this.setState({
      anchorX: undefined,
      anchorY: undefined
    })
  }

  render() {
    return (
      <div
        draggable="true"
        onMouseDown={this.setAnchor}
        onMouseUp={this.resetAnchor}
        onDrag={this.onDrag}
        style={{
          position: 'absolute',
          top: 0,
          left: 40,
          right: 0,
          height: 40,
          cursor: 'move',
          opacity: 0,
          zIndex: 1
        }}
      />)
  }
}

DragAnchor.propTypes = {
  onDrag: PropTypes.func,
  getDraggedRect: PropTypes.func
};

export default DragAnchor;



// WEBPACK FOOTER //
// ./modules/Ooyala/component/DragAnchor.js